document.querySelectorAll('.faq-item').forEach(function (item) {
  var summary = item.querySelector('.faq-item__row');
  var answer = item.querySelector('.faq-item__answer');

  if (!answer) return;

  summary.addEventListener('click', function (e) {
    e.preventDefault();

    var isOpen = item.hasAttribute('open');

    if (isOpen) {
      closeItem();
    } else {
      // Close other items first (accordion behavior)
      document.querySelectorAll('.faq-item[open]').forEach(function (openItem) {
        if (openItem !== item) {
          var otherAnswer = openItem.querySelector('.faq-item__answer');
          animateClose(openItem, otherAnswer);
        }
      });

      openItem();
    }
  });

  function openItem() {
    item.setAttribute('open', '');
    answer.style.height = 'auto';
    var height = answer.offsetHeight;
    answer.style.height = '0px';
    answer.offsetHeight; // force reflow
    answer.style.height = height + 'px';
  }

  function closeItem() {
    animateClose(item, answer);
  }

  function animateClose(itemEl, answerEl) {
    answerEl.style.height = answerEl.offsetHeight + 'px';
    answerEl.offsetHeight; // force reflow
    answerEl.style.height = '0px';

    answerEl.addEventListener('transitionend', function handler() {
      itemEl.removeAttribute('open');
      answerEl.removeEventListener('transitionend', handler);
    });
  }
});